import { useEffect } from 'react';
import { generatePath, useMatches, useNavigate, useParams } from 'react-router-dom';
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { LIVE_PAGE } from '../../constants/app';
import { FLEET_ASSETS_PAGE, FLEET_ROUTES_SECTION_ID } from '../../constants/fleet';
import useEffectOnce from '../../hooks/useEffectOnce';
import { isFleetModuleState, workspaceState, workspacesState } from '../../storage/app';
import { getPageRoute } from '../../utils/pages';

export function WorkspaceProvider() {
  const { id } = useParams();
  const workspaces = useRecoilValue(workspacesState);
  const [workspace, setWorkspace] = useRecoilState(workspaceState);
  const setIsFleetModule = useSetRecoilState(isFleetModuleState);
  const resetIsFleetModule = useResetRecoilState(isFleetModuleState);
  const navigate = useNavigate();
  const matches = useMatches();

  useEffectOnce(() => {
    if ((workspace && workspace._id === id) || !workspaces || workspaces?.length === 1) return;
    const validWorkspace = workspaces.find((w) => w._id === id);
    if (validWorkspace && (!workspace || workspace._id !== id)) {
      setWorkspace(validWorkspace);
    } else {
      setWorkspace(undefined);
    }
  });

  useEffect(() => {
    if (workspaces?.length === 1) {
      setWorkspace(workspaces[0]);
    }
  }, [workspaces]);

  useEffect(() => {
    if (!workspace) {
      return;
    }
    const currentRoute = matches[matches.length - 1];
    const route = getPageRoute(currentRoute.id);
    if (!route) {
      const mainRouteId = matches[0].id;
      const isFleet = mainRouteId === FLEET_ROUTES_SECTION_ID;
      const redirectRoute = isFleet ? FLEET_ASSETS_PAGE.route : LIVE_PAGE.route;
      navigate(generatePath(redirectRoute, { id: workspace._id }), { replace: true });
    } else if (currentRoute.params.id !== workspace._id) {
      navigate(generatePath(route, { ...currentRoute.params, id: workspace._id }), { replace: true });
    }
  }, [workspace]);

  useEffect(() => {
    const mainRouteId = matches[0].id;
    if (mainRouteId === FLEET_ROUTES_SECTION_ID) {
      setIsFleetModule(true);
      return;
    }
    resetIsFleetModule();
  }, [matches]);

  return null;
}
